import React, { useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthContext, API } from "@/App";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, loading: authLoading, checkAuth } = useContext(AuthContext);
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    // If user data was passed from AuthCallback, skip the check
    if (location.state?.user) {
      setIsAuthenticated(true);
      return;
    }

    // Otherwise verify session server-side
    const verifyAuth = async () => {
      try {
        const res = await fetch(`${API}/auth/me`, {
          credentials: "include"
        });
        if (res.ok) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (e) {
        setIsAuthenticated(false);
      }
    };

    if (!authLoading && !user) {
      verifyAuth();
    } else if (user) {
      setIsAuthenticated(true);
    }
  }, [user, authLoading, location.state]);

  // Show loading while checking auth
  if (isAuthenticated === null || authLoading) {
    return (
      <div className="min-h-screen bg-obsidian flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated && !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (requireAdmin && !user?.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
